const metaHospedagem = { rules: ['HOSPEDAGEM-00'] };

const routes = [
    {
        path: 'hospedagem',
        name: 'SolicitacoesServicos_Hospedagem',
        component: () => import('./listagem/Listagem.vue'),
        meta: metaHospedagem,
    },
    {
        path: 'hospedagem/nova',
        name: 'SolicitacoesServicos_Hospedagem_Nova',
        component: () => import('./formulario/NovaEdicao.vue'),
        meta: metaHospedagem,
    },
    {
        path: 'hospedagem/editar/:id',
        name: 'SolicitacoesServicos_Hospedagem_Editar',
        component: () => import('./formulario/NovaEdicao.vue'),
        meta: metaHospedagem,
    },
    {
        path: 'hospedagem/prazos-contratacao',
        name: 'SolicitacoesServicos_Hospedagem_Prazos',
        component: () => import('./prazos/ManutencaoPrazos.vue'),
        meta: { rules: ['HOSPEDAGEM-24'] },
    },
    {
        path: 'hospedagem/:id',
        name: 'SolicitacoesServicos_Hospedagem_Detalhar',
        component: () => import('./detalhamento/Detalhamento.vue'),
        meta: metaHospedagem,
    },
];

export default routes;
